module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAM1BMVEUAAADNzc3MzMzNzc3Ly8vMzMzHx8fMzMzMzMzMzMzMzMzMzMzPz8/Nzc3MzMzKysrMzMxjZtMPAAAAEHRSTlMAf7+fQO8g32DPkFAQj28wsJvYrAAAAH1JREFUOMvlzEsOgkAURNFq4NH81N7/an3RQRkQ7tTEO6vkpLTvHlEElZYVNKjSoEpjxcbqaEDZWIGxImNlA8rmqMBY2YBKg+rWoOKfS9W4UDCqmvholba1rxdiGTa9OzWdsj9DdcwWQL2y4RfQvEeebjpBMepTzd9Q99CrJ/2QMFK2cNWqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = P7rK
// module chunks = 1